import { c as e } from "./createVueComponent-C49sYEj8.js";
var a = e("outline", "loader-2", "Loader2", [["path", { d: "M12 3a9 9 0 1 0 9 9", key: "svg-0" }]]);
export {
  a as I
};
